import { useMenuVariant } from 'experiments/menu-variant/use-menu-variant';
import { IFeatureMenuQuery, useFeatureMenuQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';
import { withSimpleCache } from 'state/graphql/with-simple-cache';

interface IUseFeatureMenuValue {
  menuId: string;
  featureMenu: IFeatureMenuQuery['FeatureMenu'];
  featureMenuLoading: boolean;
}

const useCachedFeatureMenuQuery = withSimpleCache(useFeatureMenuQuery);

export const useFeatureMenu = (): IUseFeatureMenuValue => {
  const { featureMenuId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useCachedFeatureMenuQuery({
    variables: { featureMenuId },
    skip: !featureMenuId,
  });

  const featureMenu = data?.FeatureMenu ?? null;
  const menuVariant = useMenuVariant(featureMenu);
  const menuId = menuVariant?.menuVariantId || featureMenu?.defaultMenu?._id || '';

  const featureMenuLoading = featureIdsLoading || loading;

  return {
    menuId,
    featureMenu,
    featureMenuLoading,
  };
};
